import { getObjKeySort } from './utils.js';
import { signData } from './sign.js';
import { GenerateKey, Encrypt, Decrypt } from './aes.js';

/*
 ** 加密签名封装
 ** @params data 请求数据
 ** @params webToken  登录token
 ** @params needEncrypt  是否对请求数据data加密,默认true
 */
export function encryptSignData(data, webToken, needEncrypt = true) {
  const timestamp = new Date().getTime();
  let reqData = data;
  // 需要对数据加密
  if (needEncrypt) {
    // 获取密钥
    let key = GenerateKey(webToken, timestamp);
    let dataSortObj = getObjKeySort(data).sortObj;
    let dataString = JSON.stringify(dataSortObj);
    let encryptData = Encrypt(dataString, key);
    reqData = {
      encryptData
    };
  }
  return signData(reqData, webToken, timestamp);
}

/*
 ** 解密返回的数据
 ** @params encryptData 加密数据
 ** @params webToken 登录token
 ** @params timestamp 时间戳
 */
export function decryptRes(encryptData, webToken, timestamp) {
  let key = GenerateKey(webToken, timestamp);

  return Decrypt(encryptData, key);
}
